module.exports = __webpack_public_path__ + "static/media/experientialmarketing.e3476d2f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/static/experientialmarketing.mp4
// module id = 168
// module chunks = 0